import { BOARDS_MAPPER } from "@onesolution/constants";
import { mondayClient } from "@onesolution/monday/monday";
import getKeyCloakAdminClient from "@onesolution/utils/userSync/keycloakAdminClient";
import unlinkKryssSso from "@onesolution/utils/userSync/unlinkKryssSso";
import { createServerFn } from "@tanstack/react-start";

import z from "zod";

const realm = import.meta.env.VITE_KEYCLOAK_REALM;
const keycloakUrl = import.meta.env.VITE_KEYCLOAK_AUTH_URL;
const redirectUrl = import.meta.env.VITE_FRONT_AUTH_URL;
const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID;
export const LoginSsoUrlParams = z.object({
	email: z.string(),
});

function buildOidUlr(alias: string) {
	return `${keycloakUrl}/realms/${realm}/protocol/openid-connect/auth?client_id=${encodeURIComponent(clientId)}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=openid&kc_idp_hint=${encodeURIComponent(alias)}`;
}

export const getLoginSsoUrl = createServerFn()
	.validator(LoginSsoUrlParams)
	.handler(async ({ data }) => {
		try {
			const keycloakClient = await getKeyCloakAdminClient();

			const userInfos = await keycloakClient.users.find({
				email: data.email,
			});
			const keycloakUserInfos = userInfos?.[0];
			if (!keycloakUserInfos) return "No keyclaok user info";

			// const providersInfos = await keycloakClient.identityProviders.find();
			// const alreadyLinkedProviders =
			// 	await keycloakClient.users.listFederatedIdentities({
			// 		id: keycloakUserInfos.id!,
			// 		realm,
			// 	});
			//if (!alreadyLinkedProviders.length) {
			const mondayWorkspaceId =
				keycloakUserInfos.attributes?.monday_workspace_id?.[0];
			if (!mondayWorkspaceId) return "No workspace id set for this user";

			const boardsInfos = await mondayClient.query.boardsFromClientWorkspace({
				user: { monday_workspace_id: mondayWorkspaceId },
			});
			if (!boardsInfos) return "wrong client configuration";

			const frontBoardId = boardsInfos.find((b) =>
				b.name.includes(BOARDS_MAPPER.front),
			)?.id;
			if (!frontBoardId) return "wrong client configuration (board id)";

			const clientInfos = await mondayClient.query.clientInfos({
				boards: {
					front: frontBoardId,
				},
			});
			if (!clientInfos) return "Can't find related monday client infos";

			const defaultClientSso = clientInfos?.sso?.[0]?.label;
			if (!defaultClientSso) return "No default SSO set for this client";

			await unlinkKryssSso(data.email);

			return [
				{ provider: defaultClientSso, url: buildOidUlr(defaultClientSso) },
			];
			//}

			// return alreadyLinkedProviders.map(({ identityProvider }) => {
			// 	const providerInfo = providersInfos.find(
			// 		(p) => p.alias === identityProvider,
			// 	)!;

			// 	return {
			// 		provider: providerInfo.alias!,
			// 		url: buildOidUlr(providerInfo.alias!),
			// 	};
		} catch (e) {
			console.error(e);

			return (e as Error).toString();
		}
	});
